import { NavItemType } from '../types/menu';
import studentsMenu from './students-menu';
import supportMenu from './supportMenu';

const miniMenuItems: { items: NavItemType[] } = {
  items: [studentsMenu, supportMenu],
};
export default miniMenuItems;
